import { defineStore } from "pinia";
import UserService from "../services/UserService";
export const useUserStore = defineStore("user", {
    state: () => ({
        user: {},
        secaoEdicaoDados: "dados-pessoais",
    }),
    getters: {},
    actions: {
        async fetchLoggedUser() {
            const res = await UserService.identificacaoUsuarioLogado();
            if (res) {
                this.$state.user = res;
            }
        },
        async showModalEdicaoMeuPerfil(secao) {
            this.secaoEdicaoDados = secao;
            $("#modal-edicao-meu-perfil").modal("show");
        },
    },
});
